import { CategorySelector } from "./display/CategorySelector.js";
import { IdlemodeGallery } from "./display/IdlemodeGallery.js";
import { MultiVideoSelector } from "./display/MultiVideoSelector.js";
import { IVideoSelector } from "./display/VideoSelector.js";
import { VideoView } from "./display/VideoView.js";
import { DataManager } from "./model/DataManager.js";
import { VOVideo } from "./model/DataStructure.js";
import { Language } from "./model/Language.js";
import { Resource } from "./model/Resource.js";

export type ApplicationIdlemode = "default" | "gallery" | "none";

//@ts-ignore
window.$ = jQuery;

export class Application {

    private _data: DataManager;

    private _element: HTMLDivElement;

    private _videoView: VideoView;
    private _videoSelector: IVideoSelector;
    private _categorySelector: CategorySelector;
    private _screenWidth: number = 1920;
    private _screenHeight: number = 1080;
    private _idlemode: ApplicationIdlemode = "none";
    private _idleTimeout: any = null;
    private _idlemodeGallery: IdlemodeGallery;

    constructor() {

        this._element = document.getElementById("app") as HTMLDivElement;
        Resource.init(this._element);


        if (!e5.Caps.isChrome) {
            e5.Toast.showText("Sorry, please use Chromium based browser", 40);
            return;
        }

        this._data = new DataManager();
        this._data.onComplete.add(() => this.ready());
        this._data.load(Resource.DATA);

        this._screenWidth = this._element.offsetWidth;
        this._screenHeight = this._element.scrollHeight;
        this.resize();
        window.addEventListener("resize", () => this.resize());
    }

    private ready(): void {

        document.body.classList.add("no-transition");

        document.body.classList.toggle("fullscreen", this._data.config.fullscreen);

        Language.init(this._data.config);

        Language.data = this._data.data;

        this._videoView = new VideoView(this._data);
        this._element.appendChild(this._videoView.element);
        this._videoView.onSelectVideo.add((video) => {
            this.openVideo(video);
        });

        this._categorySelector = new CategorySelector(this._data);
        this._element.appendChild(this._categorySelector.element);

        // this._videoSelector = new VideoSelector(this._data.config.videos, this._data);
        this._videoSelector = new MultiVideoSelector(this._data);
        this._element.appendChild(this._videoSelector.element);
        this._videoSelector.onSelectVideo.add((video) => {
            this.openVideo(video);
        });

        this._categorySelector.onSelectCategory.add((category) => {
            this._videoSelector.category = category;
        });

        var video = this._data.config.videos[0];
        this._videoSelector.video = video;
        this._videoView.video = video;

        this._idlemodeGallery = new IdlemodeGallery(this._data);

        setTimeout(() => {
            this._element.classList.remove("progress");
            document.querySelector("body>.loader").remove();
            document.body.classList.remove("no-transition");
        });

        document.addEventListener("keyup", (e) => {
            if (e.keyCode == 82) {//"R"
                this.setIdleMode(this._data.config.idlemode);
            }
        }, true);

        document.addEventListener("pointerdown", (e) => {
            this.refreshIdleTimeout();
            if (this._idlemode != "none") {
                this.setIdleMode("none");
                return;
            }
        }, true);
        this.refreshIdleTimeout();
    }

    private refreshIdleTimeout(): void {
        clearTimeout(this._idleTimeout);
        this._idleTimeout = setTimeout(
            () => this.setIdleMode(this._data.config.idlemode),
            1000 * this._data.config.idlemode_timeout);
    }

    private setIdleMode(idleMode: ApplicationIdlemode): void {
        if (this._idlemode == idleMode) {
            return;
        }
        clearTimeout(this._idleTimeout);

        //Exit idle mode
        if (this._idlemode == "none") {

        }
        else if (this._idlemode == "default") {

        }
        else if (this._idlemode == "gallery") {
            this._idlemodeGallery.hide();
            this.openVideo(this._idlemodeGallery.video);
            // this._videoView.play();
        }

        this._idlemode = idleMode;

        if (this._idlemode != "none") {
            Language.current = this._data.config.language;
            document.body.classList.toggle("fullscreen", this._data.config.fullscreen);
            this._categorySelector.reset();
            this._videoView.reset();
        }

        //Enter idle mode
        if (idleMode == "none") {

        }
        else if (idleMode == "default") {


        }
        else if (idleMode == "gallery") {
            this._videoView.pause();
            this._idlemodeGallery.show();
        }
    }

    private openVideo(video: VOVideo): void {
        this._videoSelector.video = video;
        this._videoView.video = video;
    }

    private resize(): void {
        var elements = [this._element];

        var w = window.innerWidth;
        var h = window.innerHeight;
        var upScaling = e5.Url.params.has("upscaling");

        for (var element of elements) {
            var elementWidth = element.offsetWidth;
            var elementHeight = element.offsetHeight;

            var scale = Math.min(w / elementWidth, h / elementHeight);
            if (!upScaling)
                scale = Math.min(scale, 1);

            if (scale == 1 && w === elementWidth && h === elementHeight) {
                element.style.transform = "initial";
                element.style.top = "50%";
                element.style.left = "50%";
                element.style.marginTop = -this._screenHeight * 0.5 + "px";
                element.style.marginLeft = -this._screenWidth * 0.5 + "px";
            }
            else {
                var x = Math.round((w - elementWidth * scale) * 0.5);
                var y = Math.round((h - elementHeight * scale) * 0.5);
                element.style.transform = "translate(" + Math.round(x) + "px, " + Math.round(y) + "px) scale(" + scale + ")";
                element.style.top = null;
                element.style.left = null;
                element.style.marginTop = null;
                element.style.marginLeft = null;
            }
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new Application();
});